import Vue from "vue";
import "./cube-ui";
import "./iView-ui";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import cjcAPI from "./cjcAPI";
import "normalize.css";
import "./registerComponent";
import "vant/lib/index.css";
import wangEditor from "@/utils/wangEditor";
import { judeEnv } from "@/utils/util";

import { Cell, CellGroup, Popup, Field, Uploader, Button, Toast } from "vant";

(async () => {
  Vue.use(Cell)
    .use(CellGroup)
    .use(Field)
    .use(Uploader)
    .use(Button)
    .use(Toast)
    .use(Popup);
  window.goMessage = wangEditor.goMessage;
  window.goServe = wangEditor.goServe;
  window.goOfficialAccounts = wangEditor.goOfficialAccounts;
  window.messageImg = wangEditor.messageImg;
  Vue.config.productionTip = false;
  Vue.prototype.isApiAppOpenService = true
  Vue.use(cjcAPI);
  const {data:{result,status}} = await store.dispatch('getAppWebsiteInfo',{})
  if (status === 1000) {
    Vue.prototype.APPName = result.title;
  }else{
    Vue.prototype.APPName ='移动智慧校园平台';
  }
  console.log(Vue.prototype.APPName);
  Vue.prototype.environment = await judeEnv();
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
})()
